import { getTracking, setTracking } from "@website/store/tracking";
import TimeSyncInitializer from "@website/utils/time-sync-initializer";
import { GoogleTagManager } from "@website/widget/scripts/google-tag-manager";
import { Webengage } from "@website/widget/scripts/webengage";
import { useRouter } from "next/router";
import Script from "next/script";
import { FC, useEffect } from "react";

export const Scripts: FC<{
  webengageLicence?: string;
  gtmLicence?: string;
  serverNow: number;
}> = ({ webengageLicence, gtmLicence, serverNow }) => {
  const router = useRouter();

  useEffect(() => {
    if (
      router.query.token &&
      router.query.app_version &&
      router.query.ispwa !== "true"
    ) {
      setTracking((previous) => ({ ...previous, isNative: true }));
    }
    if (process.env.NEXT_PUBLIC_BUILD_ENV === "production") {
      navigator?.serviceWorker?.register("/sw.js?v=6");
    }
  }, [router.query.app_version, router.query.ispwa, router.query.token]);

  return (
    <>
      {gtmLicence && <GoogleTagManager gtmId={gtmLicence} />}
      {webengageLicence && <Webengage licence={webengageLicence} />}
      {getTracking().isNative && (
        <Script
          src="https://web-cdn.snapp.ir/shared/scripts/super-app-api.js"
          strategy="afterInteractive"
        />
      )}
      <TimeSyncInitializer serverNow={serverNow} />
    </>
  );
};
